import { render } from "./CellEditModal.vue?vue&type=template&id=01206cb5"
import script from "./CellEditModal.vue?vue&type=script&lang=js"
export * from "./CellEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__